import { ChevronRight } from "lucide-react";
import { IDS } from "@/constants/testIds";

const GENDERS = ["female", "male", "nonbinary", "prefer-not"];

const Field = ({ label, children }) => (
  <label className="flex flex-col gap-2">
    <span className="text-[10px] font-[Manrope] font-bold tracking-[0.2em] uppercase text-stone-500">{label}</span>
    {children}
  </label>
);

export default function OnboardingStep1({ form, setForm, saving, onNext }) {
  return (
    <div className="flex flex-col gap-5">
      <Field label="Your name">
        <input
          data-testid={IDS.nameInput}
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="input"
          placeholder="e.g., Ananya"
        />
      </Field>
      <Field label="Gender">
        <div className="flex flex-wrap gap-2" data-testid={IDS.genderSelect}>
          {GENDERS.map((g) => (
            <button
              key={g}
              onClick={() => setForm({ ...form, gender: g })}
              className={`px-4 py-2 rounded-full border text-sm font-[Manrope] capitalize transition-colors ${
                form.gender === g
                  ? "bg-stone-900 text-white border-transparent"
                  : "bg-white border-stone-200 text-stone-700"
              }`}
            >
              {g === "prefer-not" ? "Prefer not" : g}
            </button>
          ))}
        </div>
      </Field>
      <Field label="Age">
        <input
          data-testid={IDS.ageInput}
          type="number"
          value={form.age}
          onChange={(e) => setForm({ ...form, age: e.target.value })}
          className="input"
          placeholder="e.g., 28"
        />
      </Field>
      <button
        data-testid={IDS.onbNext}
        onClick={onNext}
        disabled={saving}
        className="btn-primary mt-4"
      >
        Continue <ChevronRight size={16} strokeWidth={1.5} />
      </button>
    </div>
  );
}
